import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-group',
  templateUrl: './context-menu-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuGroupComponent {
  @Input()
  canGroup?: boolean;

  @Input()
  canUngroup?: boolean;

  @Output()
  groupSelection = new EventEmitter();

  @Output()
  ungroupSelection = new EventEmitter();
}
